import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
    selector: 'app-partner-administration',
    template: `
        <app-list-layout-with-routing [Path]="PageMetaPath" TabLabel="Partnerliste">
            <app-partner-list></app-partner-list>
        </app-list-layout-with-routing>
    `,
    styles: [``],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PartnerAdministrationComponent {
    PageMetaPath = 'partner'; // ToDo PartnerAdministrationMeta anlegen
}
